import type { ActiveFieldHeaderInfo, GetActiveFieldHeaderInfo } from '../../types.tsx';
import { messages } from './messages.tsx';

/**
 * Marker for required fields
 */
export const requiredFieldActiveFieldHeaderInfo: GetActiveFieldHeaderInfo = ({
	associatedField,
	isRequirabilityDisplayed,
}): ActiveFieldHeaderInfo | undefined => {
	if (isRequirabilityDisplayed && associatedField.required) {
		return { shortText: messages.required };
	}
	return undefined;
};
